import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { MenuLimitedRequestBody, MenuLimitedResponse } from "./types";

export class MenuLimitedAPI extends BaseAPI<
  MenuLimitedRequestBody,
  MenuLimitedResponse
> {
  protected route = ApiRoutes.menu.limited;
  protected method = RequestMethod.PUT;
}
